<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">

      <el-tab-pane label="出入库日汇总" name="dailySum">
        <search-form-template
          ref="searchOptions1"
          :searchOptions="searchOptions1"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="dailySum" :tableOptions="dailySum"></table-template>
      </el-tab-pane>
      <el-tab-pane label="出入库月汇总" name="monthlySum">
        <search-form-template
          ref="searchOptions2"
          :searchOptions="searchOptions2"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="monthlySum" :tableOptions="monthlySum"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import searchFormTemplate from '@/components/template/searchFormTemplate';
import tableTemplate from '@/components/template/tableTemplate';
import api from '@/config/api';

import userPower from '@/mixin/userPower'

export default {
  mixins: [userPower],
  name: 'RoleManager',
  components: {
    tableTemplate,
    searchFormTemplate,
  },
  data() {
    return {
      activeTab: 'dailySum',
      loading: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ''}
        }
      },
      // 高级搜索条件
      searchOptions1: {
        simple: [{label: '', prop: 'goodsName', type: 'input', isFuzzy: true, placeholder: '请输入条码/品名/自编码'}],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            // defaultValue: '10',
            span: 24
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 6,
            data: [],
            isHasAll: true,
            change: this.storeChange,
            url: api.system.seStore
          },
          {
            label: "类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
          {
            label: '品牌',
            type: 'select',
            prop: 'goodsBrandId',
            data: [],
            span: 6,
            // url: api.archives.brand
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            data: [],
            span: 6,
            // url: api.archives.supplier,
          },
          // {
          //   label: '商品名称',
          //   prop: 'goodsName',
          //   type: 'input',
          //   span: 6,
          //   placeholder: '请输入商品名称'
          // },
          // {
          //   label: '条码',
          //   prop: 'barCode',
          //   type: 'input',
          //   span: 6,
          //   placeholder: '请输入条码'
          // },
          // {
          //   label: "仓库",
          //   type: "select",
          //   prop: "warehouseId",
          //   url: api.warehouse.warehouse,
          //   param: {relateType: this.$utils.getSysUser().storeId?20:10},
          //   data: [],
          //   span: 6,
          // },

          {
            label: '进项金额',
            prop: 'EnterTotalPrice',
            type: 'numberRange',
            span: 6
          },
          {
            label: '出项金额',
            prop: 'OutTotalPrice',
            type: 'numberRange',
            span: 6
          },
          // {
          //   label: '出入库类型',
          //   prop: 'operationType',
          //   type: 'radio',
          //   span: 24,
          //   data: [{label: '全部', value: undefined}, {label: '入库', value: 10}, {label: '出库', value: 20}],
          // }
        ]
      },
      searchOptions2: {
        simple: [{label: '', prop: 'goodsName', type: 'input', isFuzzy: true, placeholder: '请输入条码/品名/自编码'}],
        complex: [
          {
            label: '选择月份',
            prop: 'CreateDttm',
            type: 'dateMonthPicker',
            dateType: 'month',
            change: this.monthChange,
            span: 6
          },
          {
            label: '选择月份',
            prop: 'edCreateDttm',
            type: 'dateMonthPicker',
            dateType: 'month',
            span: 24,
            hidden: true
          },
          {
            label: '选择月份',
            prop: 'stCreateDttm',
            type: 'dateMonthPicker',
            dateType: 'month',
            span: 24,
            hidden: true
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 6,
            data: [],
            isHasAll: true,
            change: this.storeChange,
            url: api.system.seStore
          },
          {
            label: "类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
          {
            label: '品牌',
            type: 'select',
            prop: 'goodsBrandId',
            data: [],
            span: 6,
            // url: api.archives.brand
          },

          {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            data: [],
            span: 6,
            // url: api.archives.supplier,
          },
          // {
          //   label: '商品名称',
          //   prop: 'goodsName',
          //   type: 'input',
          //   span: 6,
          //   placeholder: '请输入商品名称'
          // },
          // {
          //   label: "仓库",
          //   type: "select",
          //   prop: "warehouseId",
          //   url: api.warehouse.warehouse,
          //   param: {relateType: this.$utils.getSysUser().storeId?20:10},
          //   data: [],
          //   span: 6,
          // },
          // {
          //   label: '条码',
          //   prop: 'barCode',
          //   type: 'input',
          //   span: 6,
          //   placeholder: '请输入条码'
          // },
          {
            label: '进项金额',
            prop: 'EnterTotalPrice',
            type: 'numberRange',
            span: 6
          },
          {
            label: '出项金额',
            prop: 'OutTotalPrice',
            type: 'numberRange',
            span: 6
          },
          // {
          //   label: '出入库类型',
          //   prop: 'operationType',
          //   type: 'radio',
          //   span: 24,
          //   data: [{label: '全部', value: undefined}, {label: '入库', value: 10}, {label: '出库', value: 20}],
          // }
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '打印',
          code: 'print'
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        }
      ],
      // 出入库日汇总
      dailySum: {
        showSummary: true,
        summaryColumns: ['enterGoodsNum', 'enterTotalPrice', 'outGoodsNum', 'outTotalPrice'],
        indexShow: true,//是否显示索引
        param: {
          sumType: 10,
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }, // 汇总类型  10 日汇总 20 月汇总
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center'
          },
          {
            label: '日期',
            prop: 'businessCreateDttm',
            width: '120',
            align: 'center'
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '150',
            align: 'center'
          }, {
            label: '商品名称',
            prop: 'goodsName',
            width: '160',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'goodsSpecs',
            width: '70',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '70',
            align: 'center'
          },
          {
            label: '类别',
            prop: 'categoryName',
            width: '150',
            align: 'center'
          },
          {
            label: '品牌',
            prop: 'brandName',
            width: '150',
            align: 'center'
          },
          // {
          //   label: "供应商",
          //   prop: "supplierName",
          //   width: "190",
          //   align: "center",
          // },
          // {
          //   label: '单价',
          //   prop: 'enterTotalPrice',
          //   width: '120',
          //   align: 'center'
          // },
          {
            label: '进项数量',
            prop: 'enterGoodsNum',
            width: '120',
            align: 'center'
          },
          {
            label: '进项金额',
            prop: 'enterTotalPrice',
            width: '120',
            align: 'center'
          },
          {
            label: '出项数量',
            prop: 'outGoodsNum',
            width: '120',
            align: 'center'
          },
          {
            label: '出项金额',
            prop: 'outTotalPrice',
            width: '120',
            align: 'center'
          },
        ],
        url: api.warehouse.querySummary
      },
      // 出入库月汇总
      monthlySum: {
        showSummary: true,
        summaryColumns: ['enterGoodsNum', 'enterTotalPrice', 'outGoodsNum', 'outTotalPrice'],
        indexShow: true,//是否显示索引
        param: {
          sumType: 20,
          stCreateDttm: this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          edCreateDttm: this.$moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        },
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center'
          },
          {
            label: '月份',
            prop: 'businessCreateDttm',
            width: '120',
            align: 'center'
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '150',
            align: 'center'
          }, {
            label: '商品名称',
            prop: 'goodsName',
            width: '120',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'goodsSpecs',
            width: '70',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '70',
            align: 'center'
          },
          {
            label: '类别',
            prop: 'categoryName',
            width: '150',
            align: 'center'
          },
          {
            label: '品牌',
            prop: 'brandName',
            width: '150',
            align: 'center'
          },
          // {
          //   label: "供应商",
          //   prop: "supplierName",
          //   width: "190",
          //   align: "center",
          // },
          {
            label: '进项数量',
            prop: 'enterGoodsNum',
            width: '120',
            align: 'center'
          },
          {
            label: '进项金额',
            prop: 'enterTotalPrice',
            width: '120',
            align: 'center'
          },
          {
            label: '出项数量',
            prop: 'outGoodsNum',
            width: '120',
            align: 'center'
          },
          {
            label: '出项金额',
            prop: 'outTotalPrice',
            width: '120',
            align: 'center'
          },
        ],
        url: api.warehouse.querySummary
      }
    };
  },
  created() {
    this.title = document.title;
    if (this.$utils.getSysUser().storeId) {
      this.storeChange(this.$utils.getSysUser())
    }
    this.setStore(this.searchOptions1.complex)
    this.setStore(this.searchOptions2.complex)
  },
  mounted() {
  },
  methods: {
    // 选择门店
    storeChange(form) {
      form.goodsBrandId = '';
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions1.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          this.searchOptions2.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions1.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          this.searchOptions2.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      })
    },
    // 获取某个月的总天数
    getDaysOfMonth(year, month) {
      let date = new Date(year, month, 0);
      let days = date.getDate();
      return days;
    },
    // 选择月份
    monthChange(val) {
      let year = ''
      let month = ''
      if (val && val.CreateDttm) {
        year = val.CreateDttm.split('-')[0]
        month = val.CreateDttm.split('-')[1]
      }
      val.stCreateDttm = val.CreateDttm + '-01' + ' ' + '00:00:00'
      val.edCreateDttm = val.CreateDttm + '-' + this.getDaysOfMonth(year, month) + ' ' + '23:59:59'
    },
    // 点击重置 刷新列表
    clearSearch() {
      this.$refs['dailySum'].clearSearch();
      this.$refs['monthlySum'].clearSearch();
      if (!this.$utils.getSysUser().storeId) {
        this.searchOptions1.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        this.searchOptions1.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.searchOptions2.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        this.searchOptions2.complex.filter(item => item.prop === 'supplierId')[0].data = []
      }
    },
    // 点击搜索
    searchSubmit(param) {
      if (this.activeTab === 'monthlySum') {
        param.CreateDttm = null
      }
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    tabChange() {
      this.$refs.searchOptions1.complexClear()
      this.$refs.searchOptions2.complexClear()
      this.$refs[this.activeTab].searchParam = {}
      this.$refs[this.activeTab].operationSuccess();
    },
    exportExcel() {
      let fileName, param;
      let url = api.warehouse.querySummaryGoodsExport;
      switch (this.activeTab) {
        case 'dailySum':
          param = this.$refs["dailySum"].searchParam;
          param.sumType = 10;
          fileName = '出入库日汇总_';
          break;
        case 'monthlySum':
          param = this.$refs["monthlySum"].searchParam;
          param.sumType = 20;
          fileName = '出入库月汇总_';
          break;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      this.$axios.PostBlob(url, param).then(res => {
        if (res.status === 200) {
          fileName = fileName + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
  }
}
</script>

<style scoped>
  .page-template {
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/page/warehouse/QuerySummary.vue